import script from "./CustomerInputBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInputBlock.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInputBlock.vue?vue&type=style&index=0&id=5609a67c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5609a67c"]])

export default __exports__